module.exports = __webpack_public_path__ + "img/GofiQR-iphone.09947e52.png";